import QUANTLABS_EXT_1 from "./QUANTLABS_EXT_1";

export default {
  QUANTLABS_EXT_1,
};
